import React from 'react';
import { BiCheckDouble } from 'react-icons/bi';

function UserMessage({ message }) {

    const FormatTimestamp = (timestamp) => {
        try {
            const currentDate = new Date();
            const messageDate = timestamp.toDate();

            const currentYear = currentDate.getFullYear();
            const messageYear = messageDate.getFullYear();

            const currentDay = currentDate.getDate();
            const messageDay = messageDate.getDate();

            const messageTime = messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

            let formattedTimestamp = '';

            if (currentYear !== messageYear) {
                formattedTimestamp = messageYear;
            }

            if (currentDay !== messageDay) {
                formattedTimestamp += ` ${messageDate.toLocaleDateString([], { month: 'short', day: 'numeric' })}`;
            }

            formattedTimestamp += ` ${messageTime}`;

            return formattedTimestamp.trim();
        } catch (error) {
            console.log(error.message)
        }
        return '';
    };



    return (
        <>
            <div className='user-message'>{message.content}
                <p >{FormatTimestamp(message.createdAt)} <BiCheckDouble size={15} className={`check-icon ${message.isRead ? "dark-color" : "light-color"}`} /></p>

            </div>

        </>
    );
}

export default UserMessage;
